const MANUFACTURERS_HOMEPAGE_QUERY_LIMIT = 14;

export const manufacturersHomePageQueryVariables = { limit: MANUFACTURERS_HOMEPAGE_QUERY_LIMIT };
